export const ROLE_TYPES = {
    ADMIN: 'ADMIN',
    USER: 'USER',
};
